import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AndroidOsShortcutsService } from "src/app/services/android-os-shortcuts/android-os-shortcuts.service";
import { sharedConfig } from "src/environments/shared-config";
import { environment } from "src/environments/environment";
import { EnvironmentConfigService } from "src/app/services/environment-config-service/environment-config-service";

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
  standalone: false
})
export class MainMenuComponent implements OnInit {
  version = sharedConfig.version;
  readonly enableDeviceEmulator = environment.enableDeviceEmulator;
  showEmulator: boolean = false;

  constructor(
    private router: Router,
    protected androidOsShortcuts: AndroidOsShortcutsService,
    private environmentConfig: EnvironmentConfigService,
  ) { }

  async ngOnInit() {
    if (this.enableDeviceEmulator && this.environmentConfig.showNativeDeviceEmulatorMenu) {
      this.showEmulator = true;
    }
    // this.router.events
    //   .pipe(filter(e => e instanceof NavigationEnd))
    //   .subscribe(async () => {
    //     // Only run if THIS component is currently the active one
    //     if (this.router.routerState.root.firstChild?.routeConfig?.path == 'welcome') {
    //       await this.menu.open();
    //     }
    //   });
  }

  async showHideEmulator() {
    this.showEmulator = !this.showEmulator;
  }

  async navigateToBleDebug() {
    await this.router.navigate(['/ble-debug']);
  }

  async openAndroidSystemSettings(): Promise<void> {
    await this.androidOsShortcuts.openSystemSettings();
  }

  async openAndroidGoogleProfile(): Promise<void> {
    await this.androidOsShortcuts.openGoogleProfileSettings();
  }

  async openAndroidNotifications(): Promise<void> {
    await this.androidOsShortcuts.openNotificationSettings();
  }

  async openAndroidApps(): Promise<void> {
    await this.androidOsShortcuts.openAppsSettings();
  }

  async openAndroidBrowser(): Promise<void> {
    await this.androidOsShortcuts.openDefaultBrowser();
  }
}